const s = '{';
const e = '}';
const regEx = new RegExp(`${s}(.*?)${e}`, 'gm');

export const translate = (sentence: string, vars: object) => {
    const stringExtractor = extract([s, e]);
    if (stringExtractor) {
        const varKeys = stringExtractor(sentence);
        if (varKeys) {
            const varValues: string[] = [];

            varKeys.forEach((el: string) => {
                if (vars.hasOwnProperty(el)) {
                    varValues.push(vars[el]);
                }
            });

            return sentence.replace(regEx, (_) => varValues.shift() ?? '');
        }
    }

    return sentence;
};

export const translateWithIntegrationName = (text: string, integrationName: string): string =>
    translate(text, { integrationName });

/// Returns a function that giving a string, returns an array of variables in the string.
function extract([start, end]: [string, string]): (str: string) => string[] | undefined {
    const normalise = (str: string) => str.slice(start.length, end.length * -1);
    return (str: string) => {
        return str.match(regEx)?.map(normalise);
    };
}
